import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="120"
    height="138"
    viewBox="0 0 120 138"
    fill="none"
  >
    <ellipse
      cx="60.5"
      cy="64"
      rx="22.5"
      ry="22"
      fill="url(#paint0_radial_1818_4221)"
      fillOpacity="0.5"
    />
    <circle
      cx="60.5"
      cy="64.5"
      r="24.4"
      stroke="#877629"
      strokeWidth="0.2"
      fill="none"
    />
    <path
      d="M75.9801 54.0386C74.7269 52.2111 72.9567 50.9042 70.9538 50.3278C68.9509 49.7514 66.8315 49.939 64.9363 50.8605C63.2399 51.673 62.1935 52.3704 60.5 53.6757C58.8065 52.3704 57.7601 51.6686 56.0637 50.8605C54.1685 49.939 52.0491 49.7514 50.0462 50.3278C48.0433 50.9042 46.2731 52.2111 45.0199 54.0386C43.6984 55.9606 43 58.3627 43 60.9843C43 64.7571 45.0271 68.8963 49.0245 73.2914C52.2818 76.8714 56.131 79.8032 58.1349 81.2318C58.841 81.7334 59.6617 82 60.5 82C61.3383 82 62.159 81.7334 62.8651 81.2318C64.8674 79.8032 68.7182 76.8714 71.9755 73.2914C75.9729 68.898 78 64.7571 78 60.9843C78 58.3627 77.3016 55.9606 75.9801 54.0386Z"
      fill="url(#paint1_radial_1818_4221)"
      fillOpacity="0.3"
    />
    <path
      d="M29.3264 56.1552C28.288 54.7274 26.8213 53.7064 25.1617 53.2561C23.5022 52.8058 21.7461 52.9523 20.1758 53.6723C18.7702 54.307 17.5167 55.3773 16.5 56.7976C15.4833 55.3738 14.2298 54.3036 12.8242 53.6723C11.2539 52.9523 9.49785 52.8058 7.83829 53.2561C6.17874 53.7064 4.71198 54.7274 3.67364 56.1552C2.57867 57.6567 2 59.5333 2 61.5815C2 64.529 3.67961 67.7627 6.99172 71.1964C9.69064 73.9933 12.88 76.2838 14.5403 77.3999C15.1254 77.7917 15.8054 78 16.5 78C17.1946 78 17.8746 77.7917 18.4597 77.3999C20.1187 76.2838 23.3094 73.9933 26.0083 71.1964C29.3204 67.7641 31 64.529 31 61.5815C31 59.5333 30.4213 57.6567 29.3264 56.1552Z"
      fill="#EF6FFA"
    />
    <path
      d="M74.2109 56.1552C73.101 54.7274 71.5331 53.7064 69.7591 53.2561C67.9851 52.8058 66.1079 52.9523 64.4293 53.6723C62.9268 54.307 61.5868 55.3773 60.5 56.7976C59.4132 55.3738 58.0732 54.3036 56.5707 53.6723C54.8921 52.9523 53.0149 52.8058 51.2409 53.2561C49.4669 53.7064 47.899 54.7274 46.7891 56.1552C45.6186 57.6567 45 59.5333 45 61.5815C45 64.529 46.7954 67.7627 50.336 71.1964C53.221 73.9933 56.6303 76.2838 58.4052 77.3999C59.0306 77.7917 59.7575 78 60.5 78C61.2425 78 61.9694 77.7917 62.5948 77.3999C64.3683 76.2838 67.779 73.9933 70.664 71.1964C74.2046 67.7641 76 64.529 76 61.5815C76 59.5333 75.3814 57.6567 74.2109 56.1552Z"
      fill="#FA6FCB"
    />
    <path
      d="M116.326 56.1552C115.288 54.7274 113.821 53.7064 112.162 53.2561C110.502 52.8058 108.746 52.9523 107.176 53.6723C105.77 54.307 104.517 55.3773 103.5 56.7976C102.483 55.3738 101.23 54.3036 99.8242 53.6723C98.2539 52.9523 96.4978 52.8058 94.8383 53.2561C93.1787 53.7064 91.712 54.7274 90.6736 56.1552C89.5787 57.6567 89 59.5333 89 61.5815C89 64.529 90.6796 67.7627 93.9917 71.1964C96.6906 73.9933 99.88 76.2838 101.54 77.3999C102.125 77.7917 102.805 78 103.5 78C104.195 78 104.875 77.7917 105.46 77.3999C107.119 76.2838 110.309 73.9933 113.008 71.1964C116.32 67.7641 118 64.529 118 61.5815C118 59.5333 117.421 57.6567 116.326 56.1552Z"
      fill="#50379A"
    />
    <line
      x1="60.75"
      y1="48.75"
      x2="60.75"
      y2="38.25"
      stroke="#F4C9FF"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <line
      x1="60.75"
      y1="94.75"
      x2="60.75"
      y2="84.25"
      stroke="#F4C9FF"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <line
      x1="78.25"
      y1="66.75"
      x2="86.75"
      y2="66.75"
      stroke="#F4C9FF"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <line
      x1="33.25"
      y1="66.75"
      x2="42.75"
      y2="66.75"
      stroke="#F4C9FF"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <line
      x1="76.2373"
      y1="49.2572"
      x2="77.9875"
      y2="47.507"
      stroke="#F4C9FF"
      strokeLinecap="round"
    />
    <line
      x1="43.6777"
      y1="81.8168"
      x2="45.4279"
      y2="80.0666"
      stroke="#F4C9FF"
      strokeLinecap="round"
    />
    <line
      x1="74.7735"
      y1="80.0664"
      x2="76.5237"
      y2="81.8166"
      stroke="#F4C9FF"
      strokeLinecap="round"
    />
    <line
      x1="42.2144"
      y1="47.5073"
      x2="43.9646"
      y2="49.2575"
      stroke="#F4C9FF"
      strokeLinecap="round"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1818_4221"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.5 64) rotate(90) scale(22 22.5)"
      >
        <stop offset="0.5" stopColor="#DCFF7A" stopOpacity="0" />
        <stop offset="1" stopColor="#FFE27A" stopOpacity="0.44" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1818_4221"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.5 66) rotate(90) scale(16 17.5)"
      >
        <stop stopColor="#FA916F" stopOpacity="0" />
        <stop offset="1" stopColor="#FA916F" />
      </radialGradient>
    </defs>
  </SvgIcon>
));
